import { Routes, Route, Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

import IndexLayout from 'layouts/IndexLayout';
import MainLayout from 'layouts/MainLayout';
import AuthRoutes from 'components/AuthRoutes';
import IndexPage from 'pages/index/IndexPage';
import AllclassesattendancevwList from 'pages/allclassesattendancevw/List';
import AllstudentsenrollmentvwList from 'pages/allstudentsenrollmentvw/List';
import AttendanceList from 'pages/attendance/List';
import AttendanceView from 'pages/attendance/View';
import AttendanceAdd from 'pages/attendance/Add';
import AttendanceEdit from 'pages/attendance/Edit';
import BatchesvwList from 'pages/batchesvw/List';
import ClassesList from 'pages/classes/List';
import ClassesView from 'pages/classes/View';
import ClassesAdd from 'pages/classes/Add';
import ClassesEdit from 'pages/classes/Edit';
import CoursebatchesList from 'pages/coursebatches/List';
import CoursebatchesView from 'pages/coursebatches/View';
import CoursebatchesAdd from 'pages/coursebatches/Add';
import CoursebatchesEdit from 'pages/coursebatches/Edit';
import CoursesList from 'pages/courses/List';
import CoursesView from 'pages/courses/View';
import CoursesAdd from 'pages/courses/Add';
import CoursesEdit from 'pages/courses/Edit';
import DataprotectionkeysList from 'pages/dataprotectionkeys/List';
import DataprotectionkeysView from 'pages/dataprotectionkeys/View';
import DataprotectionkeysAdd from 'pages/dataprotectionkeys/Add';
import DataprotectionkeysEdit from 'pages/dataprotectionkeys/Edit';
import EnrollmentsList from 'pages/enrollments/List';
import EnrollmentsView from 'pages/enrollments/View';
import EnrollmentsAdd from 'pages/enrollments/Add';
import EnrollmentsEdit from 'pages/enrollments/Edit';
import PaymentsList from 'pages/payments/List';
import PaymentsView from 'pages/payments/View';
import PaymentsAdd from 'pages/payments/Add';
import PaymentsEdit from 'pages/payments/Edit';
import PaymentssummaryvwList from 'pages/paymentssummaryvw/List';
import PerformanceList from 'pages/performance/List';
import PerformanceView from 'pages/performance/View';
import PerformanceAdd from 'pages/performance/Add';
import PerformanceEdit from 'pages/performance/Edit';
import PermissionsList from 'pages/permissions/List';
import PermissionsView from 'pages/permissions/View';
import PermissionsAdd from 'pages/permissions/Add';
import PermissionsEdit from 'pages/permissions/Edit';
import RolesList from 'pages/roles/List';
import RolesView from 'pages/roles/View';
import RolesAdd from 'pages/roles/Add';
import RolesEdit from 'pages/roles/Edit';
import StudentclassattendanceList from 'pages/studentclassattendance/List';
import StudentclassattendanceView from 'pages/studentclassattendance/View';
import StudentclassattendanceAdd from 'pages/studentclassattendance/Add';
import StudentclassattendanceEdit from 'pages/studentclassattendance/Edit';
import StudentsList from 'pages/students/List';
import StudentsView from 'pages/students/View';
import StudentsAdd from 'pages/students/Add';
import StudentsEdit from 'pages/students/Edit';
import StudentvideovwList from 'pages/studentvideovw/List';
import TeachersList from 'pages/teachers/List';
import TeachersView from 'pages/teachers/View';
import TeachersAdd from 'pages/teachers/Add';
import TeachersEdit from 'pages/teachers/Edit';
import UsermasterList from 'pages/usermaster/List';
import UsermasterView from 'pages/usermaster/View';
import UsermasterAdd from 'pages/usermaster/Add';
import UsermasterEdit from 'pages/usermaster/Edit';
import View1List from 'pages/view1/List';
import AdminPage from 'pages/home/AdminPage';
import AccountPages from 'pages/account';
import HomePage from './pages/home/HomePage';
import IndexPages from './pages/index';
import ErrorPages from './pages/errors';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'assets/styles/layout.scss';
const App = () => {
	const auth = useAuth();
	function DefaultPage(){
		if(!auth.isLoggedIn){
			return <IndexPage />
		}
		return <Navigate to="/home" replace />;
	}
	function UserRoleHomePage(){
		const userRole = (auth.userRole || '').toLowerCase();
		switch(userRole){
			case 'admin':
				return <AdminPage />
			default:
				return <HomePage />;
		}
	}
	return (
		<Routes>
			<Route exact element={<AuthRoutes />}>
			<Route element={<MainLayout />}>
				<Route path="/home" element={<UserRoleHomePage />} />
				

				{/* allclassesattendancevw pages routes */}
				<Route path="/allclassesattendancevw" element={<AllclassesattendancevwList />} />
				<Route path="/allclassesattendancevw/:fieldName/:fieldValue" element={<AllclassesattendancevwList />} />
				<Route path="/allclassesattendancevw/index/:fieldName/:fieldValue" element={<AllclassesattendancevwList />} />

				{/* allstudentsenrollmentvw pages routes */}
				<Route path="/allstudentsenrollmentvw" element={<AllstudentsenrollmentvwList />} />
				<Route path="/allstudentsenrollmentvw/:fieldName/:fieldValue" element={<AllstudentsenrollmentvwList />} />
				<Route path="/allstudentsenrollmentvw/index/:fieldName/:fieldValue" element={<AllstudentsenrollmentvwList />} />

				{/* attendance pages routes */}
				<Route path="/attendance" element={<AttendanceList />} />
				<Route path="/attendance/:fieldName/:fieldValue" element={<AttendanceList />} />
				<Route path="/attendance/index/:fieldName/:fieldValue" element={<AttendanceList />} />
				<Route path="/attendance/view/:pageid" element={<AttendanceView />} />
				<Route path="/attendance/add" element={<AttendanceAdd />} />
				<Route path="/attendance/edit/:pageid" element={<AttendanceEdit />} />

				{/* batchesvw pages routes */}
				<Route path="/batchesvw" element={<BatchesvwList />} />
				<Route path="/batchesvw/:fieldName/:fieldValue" element={<BatchesvwList />} />
				<Route path="/batchesvw/index/:fieldName/:fieldValue" element={<BatchesvwList />} />

				{/* classes pages routes */}
				<Route path="/classes" element={<ClassesList />} />
				<Route path="/classes/:fieldName/:fieldValue" element={<ClassesList />} />
				<Route path="/classes/index/:fieldName/:fieldValue" element={<ClassesList />} />
				<Route path="/classes/view/:pageid" element={<ClassesView />} />
				<Route path="/classes/add" element={<ClassesAdd />} />
				<Route path="/classes/edit/:pageid" element={<ClassesEdit />} />

				{/* coursebatches pages routes */}
				<Route path="/coursebatches" element={<CoursebatchesList />} />
				<Route path="/coursebatches/:fieldName/:fieldValue" element={<CoursebatchesList />} />
				<Route path="/coursebatches/index/:fieldName/:fieldValue" element={<CoursebatchesList />} />
				<Route path="/coursebatches/view/:pageid" element={<CoursebatchesView />} />
				<Route path="/coursebatches/add" element={<CoursebatchesAdd />} />
				<Route path="/coursebatches/edit/:pageid" element={<CoursebatchesEdit />} />

				{/* courses pages routes */}
				<Route path="/courses" element={<CoursesList />} />
				<Route path="/courses/:fieldName/:fieldValue" element={<CoursesList />} />
				<Route path="/courses/index/:fieldName/:fieldValue" element={<CoursesList />} />
				<Route path="/courses/view/:pageid" element={<CoursesView />} />
				<Route path="/courses/add" element={<CoursesAdd />} />
				<Route path="/courses/edit/:pageid" element={<CoursesEdit />} />

				{/* dataprotectionkeys pages routes */}
				<Route path="/dataprotectionkeys" element={<DataprotectionkeysList />} />
				<Route path="/dataprotectionkeys/:fieldName/:fieldValue" element={<DataprotectionkeysList />} />
				<Route path="/dataprotectionkeys/index/:fieldName/:fieldValue" element={<DataprotectionkeysList />} />
				<Route path="/dataprotectionkeys/view/:pageid" element={<DataprotectionkeysView />} />
				<Route path="/dataprotectionkeys/add" element={<DataprotectionkeysAdd />} />
				<Route path="/dataprotectionkeys/edit/:pageid" element={<DataprotectionkeysEdit />} />

				{/* enrollments pages routes */}
				<Route path="/enrollments" element={<EnrollmentsList />} />
				<Route path="/enrollments/:fieldName/:fieldValue" element={<EnrollmentsList />} />
				<Route path="/enrollments/index/:fieldName/:fieldValue" element={<EnrollmentsList />} />
				<Route path="/enrollments/view/:pageid" element={<EnrollmentsView />} />
				<Route path="/enrollments/add" element={<EnrollmentsAdd />} />
				<Route path="/enrollments/edit/:pageid" element={<EnrollmentsEdit />} />

				{/* payments pages routes */}
				<Route path="/payments" element={<PaymentsList />} />
				<Route path="/payments/:fieldName/:fieldValue" element={<PaymentsList />} />
				<Route path="/payments/index/:fieldName/:fieldValue" element={<PaymentsList />} />
				<Route path="/payments/view/:pageid" element={<PaymentsView />} />
				<Route path="/payments/add" element={<PaymentsAdd />} />
				<Route path="/payments/edit/:pageid" element={<PaymentsEdit />} />

				{/* paymentssummaryvw pages routes */}
				<Route path="/paymentssummaryvw" element={<PaymentssummaryvwList />} />
				<Route path="/paymentssummaryvw/:fieldName/:fieldValue" element={<PaymentssummaryvwList />} />
				<Route path="/paymentssummaryvw/index/:fieldName/:fieldValue" element={<PaymentssummaryvwList />} />

				{/* performance pages routes */}
				<Route path="/performance" element={<PerformanceList />} />
				<Route path="/performance/:fieldName/:fieldValue" element={<PerformanceList />} />
				<Route path="/performance/index/:fieldName/:fieldValue" element={<PerformanceList />} />
				<Route path="/performance/view/:pageid" element={<PerformanceView />} />
				<Route path="/performance/add" element={<PerformanceAdd />} />
				<Route path="/performance/edit/:pageid" element={<PerformanceEdit />} />

				{/* permissions pages routes */}
				<Route path="/permissions" element={<PermissionsList />} />
				<Route path="/permissions/:fieldName/:fieldValue" element={<PermissionsList />} />
				<Route path="/permissions/index/:fieldName/:fieldValue" element={<PermissionsList />} />
				<Route path="/permissions/view/:pageid" element={<PermissionsView />} />
				<Route path="/permissions/add" element={<PermissionsAdd />} />
				<Route path="/permissions/edit/:pageid" element={<PermissionsEdit />} />

				{/* roles pages routes */}
				<Route path="/roles" element={<RolesList />} />
				<Route path="/roles/:fieldName/:fieldValue" element={<RolesList />} />
				<Route path="/roles/index/:fieldName/:fieldValue" element={<RolesList />} />
				<Route path="/roles/view/:pageid" element={<RolesView />} />
				<Route path="/roles/add" element={<RolesAdd />} />
				<Route path="/roles/edit/:pageid" element={<RolesEdit />} />

				{/* studentclassattendance pages routes */}
				<Route path="/studentclassattendance" element={<StudentclassattendanceList />} />
				<Route path="/studentclassattendance/:fieldName/:fieldValue" element={<StudentclassattendanceList />} />
				<Route path="/studentclassattendance/index/:fieldName/:fieldValue" element={<StudentclassattendanceList />} />
				<Route path="/studentclassattendance/view/:pageid" element={<StudentclassattendanceView />} />
				<Route path="/studentclassattendance/add" element={<StudentclassattendanceAdd />} />
				<Route path="/studentclassattendance/edit/:pageid" element={<StudentclassattendanceEdit />} />

				{/* students pages routes */}
				<Route path="/students" element={<StudentsList />} />
				<Route path="/students/:fieldName/:fieldValue" element={<StudentsList />} />
				<Route path="/students/index/:fieldName/:fieldValue" element={<StudentsList />} />
				<Route path="/students/view/:pageid" element={<StudentsView />} />
				<Route path="/students/add" element={<StudentsAdd />} />
				<Route path="/students/edit/:pageid" element={<StudentsEdit />} />

				{/* studentvideovw pages routes */}
				<Route path="/studentvideovw" element={<StudentvideovwList />} />
				<Route path="/studentvideovw/:fieldName/:fieldValue" element={<StudentvideovwList />} />
				<Route path="/studentvideovw/index/:fieldName/:fieldValue" element={<StudentvideovwList />} />

				{/* teachers pages routes */}
				<Route path="/teachers" element={<TeachersList />} />
				<Route path="/teachers/:fieldName/:fieldValue" element={<TeachersList />} />
				<Route path="/teachers/index/:fieldName/:fieldValue" element={<TeachersList />} />
				<Route path="/teachers/view/:pageid" element={<TeachersView />} />
				<Route path="/teachers/add" element={<TeachersAdd />} />
				<Route path="/teachers/edit/:pageid" element={<TeachersEdit />} />

				{/* usermaster pages routes */}
				<Route path="/usermaster" element={<UsermasterList />} />
				<Route path="/usermaster/:fieldName/:fieldValue" element={<UsermasterList />} />
				<Route path="/usermaster/index/:fieldName/:fieldValue" element={<UsermasterList />} />
				<Route path="/usermaster/view/:pageid" element={<UsermasterView />} />
				<Route path="/usermaster/add" element={<UsermasterAdd />} />
				<Route path="/usermaster/edit/:pageid" element={<UsermasterEdit />} />

				{/* view1 pages routes */}
				<Route path="/view1" element={<View1List />} />
				<Route path="/view1/:fieldName/:fieldValue" element={<View1List />} />
				<Route path="/view1/index/:fieldName/:fieldValue" element={<View1List />} />
				<Route path="/admin" element={<AdminPage />} />
				<Route path="/account/*" element={<AccountPages />} />
			</Route>
			</Route>
			<Route exact element={<IndexLayout />}>
				<Route path="/" element={<DefaultPage />} />
				<Route path="/*" element={<IndexPages />} />
				<Route path="/error/*" element={<ErrorPages />} />
			</Route>
		</Routes>
	);
}
export default App;
